<template><v-col cols="6"><v-card elevation="3">
	<v-btn class="float-right ma-3" color="primary" fab small @click="$emit('edit_project_data')"><v-icon>fas fa-edit</v-icon></v-btn>
	<v-card-title>
		{{project.project_name}}
	</v-card-title>
	<v-card-text>
		<ul>
			<li><b>CASE Framework<span v-show="project.line_count_case > 0"> ({{project.line_count_case}} rows)</span>:</b> <span v-html="case_framework_html"></span></li>
			<li><b>Original DB Rows<span v-show="project.line_count_db > 0"> ({{project.line_count_db}} rows)</span>:</b> <span v-html="database_export_html"></span></li>
		</ul>
		<div v-show="project.status_summary.db_row_count > 0">
			<div class="k-project-summary-data-graph-outer"><!--
				--><div class="k-project-summary-data-graph-matched" :style="'width:' + (project.status_summary.matched/project.status_summary.db_row_count*100) + '%'"></div><!--
				--><div class="k-project-summary-data-graph-parked" :style="'width:' + (project.status_summary.parked/project.status_summary.db_row_count*100) + '%'"></div><!--
				--><div class="k-project-summary-data-graph-nomatch" :style="'width:' + (project.status_summary.nomatch/project.status_summary.db_row_count*100) + '%'"></div><!--
			--></div>
			<div style="display:flex; justify-content:space-evenly">
				<div class="k-project-summary-data-stat-matched" style="flex:0 1 auto">Matched: {{ project.status_summary.matched }}</div>
				<div class="k-project-summary-data-stat-parked" style="flex:0 1 auto">Parked: {{ project.status_summary.parked }}</div>
				<div class="k-project-summary-data-stat-nomatch" style="flex:0 1 auto">No-Match: {{ project.status_summary.nomatch }}</div>
				<div class="k-project-summary-data-stat-unmatched" style="flex:0 1 auto">Unmatched: {{ project.status_summary.unmatched }}</div>
			</div>
		</div>
	</v-card-text>
	<div class="text-center pb-4">
		<v-btn :color="open_project_enabled?'primary':'#ccc'" @click="open_project">Open Project</v-btn>
	</div>
</v-card></v-col></template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	props: {
		project: { type: Object, required: true },
		project_index: { type: Number, required: true },
	},
	data() { return {
	}},
	computed: {
		...mapState(['']),
		case_framework_html() {
			if (this.project.case_framework_cached_at == 0) {
				return 'NOT YET SPECIFIED'
			}
			let d = date.format(new Date(this.project.case_framework_cached_at * 1000), 'MMM D, YYYY h:mm AA')	// Jan 1, 2019 3:12 PM
			return sr('$1 <span style="white-space:nowrap">[cached $2]</span>', this.project.case_framework_title, d)
		},
		database_export_html() {
			if (this.project.db_uploaded_at == 0) {
				return 'NOT YET UPLOADED'
			}
			let d = date.format(new Date(this.project.db_uploaded_at * 1000), 'MMM D, YYYY h:mm AA')	// Jan 1, 2019 3:12 PM
			return sr('$1 <span style="white-space:nowrap">[uploaded $2]</span>', this.project.db_filename, d)
		},
		open_project_enabled() {
			return this.project.case_framework_cached_at > 0 && this.project.db_uploaded_at > 0 && this.project.sim_scores_calculated_at > 0
		},
	},
	created() {

	},
	mounted() {
	},
	methods: {
		open_project(e) {
			if (!this.open_project_enabled) {
				this.$alert('You must specify a CASE Framework and upload a file with your original database rows in order to open the project. Click the <i class="fas fa-edit"></i> button in the upper-right corner of the project card to specify a framework and/or upload a DB file.')
				return
			}

			vapp.load_project(this.project_index)

			// if project.sim_scores_calculated_at is < case_framework_cached_at or db_uploaded_at, we need to re-calculate sim scores
			// also recalculate if shift key was held down when button was pressed
			// if (this.project.sim_scores_calculated_at < this.project.case_framework_cached_at || this.project.sim_scores_calculated_at < this.project.db_uploaded_at || ) {
			// 	// TODO: show a message so the user knows we're computing similarities here, since it may take a while
			// 	this.$store.dispatch('compute_similarities', this.project.project_id).then(()=>{
			// 		console.log('similarities computed')
			// 		vapp.load_project(this.project_index)
			// 	}).catch(()=>{
			// 		this.$alert('An error occurred while evaluating the similarities between the CASE Network Framework items and the original DB rows.')
			// 	})
			// } else {
			// 	console.log('similarities do not need to be computed')
			// 	vapp.load_project(this.project_index)
			// }
		},
	}
}
</script>

<style lang="scss">
.k-project-summary-data-graph-outer {
	background-color:#999;
	width:calc(100% - 50px);
	height:20px;
	margin:5px 25px;

	.k-project-summary-data-graph-matched {
		display:inline-block;
		background-color:$green;
		height:100%;
	}
	.k-project-summary-data-graph-parked {
		display:inline-block;
		background-color:$orange;
		height:100%;
	}
	.k-project-summary-data-graph-nomatch {
		display:inline-block;
		background-color:$red;
		height:100%;
	}
}

.k-project-summary-data-stat-matched {
	flex:0 1 auto;
	color:$green;
	font-weight:bold;
}
.k-project-summary-data-stat-parked {
	flex:0 1 auto;
	color:$orange;
	font-weight:bold;
}
.k-project-summary-data-stat-nomatch {
	flex:0 1 auto;
	color:$red;
	font-weight:bold;
}
.k-project-summary-data-stat-unmatched {
	flex:0 1 auto;
	color:#999;
	font-weight:bold;
}

</style>
